module.exports = __webpack_public_path__ + "img/salzburg_kollegienkirche.14a966db.jpg";